module.exports = "<app-loader (loadVisualizer)=\"onLoaderComplete($event)\"></app-loader>\n<div class=\"view-visualizer\"\n  role=\"main\"\n  *ngIf=\"visualizerState.DataIsReady\"\n  [@visualizerAnimate]=\"loadVisualizerAnimation\">\n  <!-- TODO verify if these ifs are needed-->\n  <app-project></app-project>\n  <app-color-groups></app-color-groups>\n</div>\n<app-modal #errorModal [modal]=\"modal\"></app-modal>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/visualizer/visualizer/visualizer.component.html
// module id = ./src/app/components/visualizer/visualizer/visualizer.component.html
// module chunks = main